/**
 * Truncates a string to a specified length
 * @param str The string to truncate
 * @param maxLength The maximum length before truncation (default: 128)
 * @returns The truncated string or the original string if it's shorter than maxLength
 */
export const getTruncatedString = (str: string, maxLength: number = 128): string => {
  return str.length > maxLength ? str.substring(0, maxLength) : str
}
